import { useParams } from "react-router-dom";
import { LoadingState } from "@/components/common/LoadingState";
import { DashboardParticipant } from "@/components/dashboard/DashboardParticipant";
import { DashboardTrainer } from "@/components/dashboard/DashboardTrainer";
import { useEnrollment } from "@/hooks/useEnrollment";

// The enrollment owner's role decides which dashboard is shown. Without a
// known role (e.g. fetch failed) the participant dashboard surfaces the error.
export const DashboardPage = () => {
  const { enrollmentId } = useParams<{ enrollmentId: string }>();
  const { data: enrollment, isLoading } = useEnrollment(enrollmentId);

  if (isLoading) return <LoadingState message="Dashboard wird geladen..." />;
  if (enrollment?.user?.role === "trainer") return <DashboardTrainer />;
  return <DashboardParticipant />;
};
